import React, { Fragment } from "react";

export const ClientWelcome = () => {
  return (
    <Fragment>
      <h2>Bienvenido</h2>
    </Fragment>
  );
};
